/* eslint-disable */
const path = require("path");

module.exports = {
  devServer: {
    open: process.platform === "darwin",
    host: "0.0.0.0",
    port: 8085, // CHANGE YOUR PORT HERE!
    https: true,
    hotOnly: false
  },
  pwa: {
    name: "Sopheo",
    themeColor: "#1976D2",
    msTileColor: "#2b5797",
    appleMobileWebAppCapable: "yes",
    appleMobileWebAppStatusBarStyle: "black",

    // configure the workbox plugin
    workboxPluginMode: "InjectManifest",
    workboxOptions: {
      // swSrc is required in InjectManifest mode.
      swSrc: "public/service-worker.js",
      exclude: [/\.map$/, /manifest\.json$/]
    }
  },
  // publicPath: '/next/',
  chainWebpack: config => {
    config.resolve.alias.set("vue$", "vue/dist/vue.esm.js");
    config.resolve.alias.set("mixins", path.resolve(__dirname, `src/mixins`));
    config.resolve.alias.set(
      "components",
      path.resolve(__dirname, `src/components`)
    );
    config.resolve.alias.set("layouts", path.resolve(__dirname, `src/layouts`));
    config.resolve.alias.set("pages", path.resolve(__dirname, `src/pages`));
    config.resolve.alias.set("assets", path.resolve(__dirname, `src/assets`));
    config.resolve.alias.set("statics", path.resolve(__dirname, `src/statics`));
    config.resolve.alias.set("plugins", path.resolve(__dirname, `src/plugins`));
  }
};
